module.exports = __webpack_public_path__ + "24.e946b8f4.png";